$.fn.calendarPlugin = function (options) {
    'use strict';

    var _elem = $(this),  // instance to $('#selector')
        _this = this,     // instance to this plugin
        _modal = $('#calendar-modal'),
        _currentURL = window.location.href,
        _eventFilterUser = $('#filter-events-user'),
        _eventFilterProject = $('#filter-events-project');

    // custom variables
    var o = $.extend({

    }, options);

    _this.init = function() {
        $(document).on('click', 'button.delete-event', function() {
            var eventId = $(this).data('id');

            _this.deleteEventById(eventId);
        });

        $(document).on('click', '.open-event[data-event-id]', function() {
            var eventId = $(this).data('event-id');

            _this.EventClick(eventId);
        });

        _eventFilterUser.dropdown('setting', 'onChange', function(value) {
            _elem.fullCalendar('rerenderEvents');
        });

        _eventFilterProject.dropdown('setting', 'onChange', function(value) {
            _elem.fullCalendar('rerenderEvents');
        });

        _this.initCalendar();
    };

    _this.initCalendar = function() {
        _elem.fullCalendar({
            header: {
				left: 'prev,next today',
				center: 'title',
				right: 'month,agendaWeek,agendaDay'
			},
            //selectable: true,
            //selectHelper: true,
            //editable: true,
            //eventDurationEditable: true,
            slotDuration: '00:30:00',
            slotLabelFormat: 'H:mm',
            scrollTime: '07:00:00',
            timeFormat: 'H:mm',
            nowIndicator: true,
            displayEventEnd: {
                month: true,
                agendaWeek: true,
                "default": true
            },
            lang: 'nl',
            cache: true,
			defaultDate: new Date(),
            defaultView: 'agendaWeek',
			eventLimit: true, // allow "more" link when too many events
			eventSources: {
                url: _currentURL,
                type: 'POST',
                data: {
                    ajax: 1,
                    request_events: 1
                },
                error: function(data) {
                    alert('Er is iets fout gegaan bij het ophalen van de gegevens. Mocht dit vaker gebeuren neem dan contact op met Stukje Design. Tel: 058 201 19 97');
                }
            },
            eventRender: function eventRender( event )
            {
                if (_eventFilterProject.length > 0)
                    return ['all', event.user_id].indexOf(_eventFilterUser.dropdown('get value')) >= 0 && ['all', event.project_id].indexOf(_eventFilterProject.dropdown('get value')) >= 0;
                else
                    return ['all', event.user_id].indexOf(_eventFilterUser.dropdown('get value')) >= 0;
            },
            eventClick: function(calEvent)
            {
                // ajax call according to event ID
                var eventId = calEvent.id;

                _this.EventClick(eventId);
            },
            //eventResize: function(data)
            //{
            //    var eventId = data.id;
            //    var eventStart = data.start.format();
            //    var eventEnd = data.end.format();
            //
            //    _this.editEvent(eventId, eventStart, eventEnd);
            //},
            eventDrop: function(event)
            {
                var eventId = event.id;
                var eventStart = event.start.format();
                var eventEnd = event.end.format();

                _this.editEvent(eventId, eventStart, eventEnd);
            }
		});
    };

    _this.deleteEventById = function(eventId)
    {
        $('#confirmation-modal').modal({
            observeChanges:true,
            allowMultiple: true,
            onShow: function() {
                /*
                    Hack for bad positioning
                 */
                setTimeout(function () {
                    $('#confirmation-modal').modal('refresh');
                }, 1);
            },
            onApprove: function() {
                $.ajax(_currentURL, { data: {ajax: 1, deleteEvent: 1, eventId: eventId},
                    type: 'POST',
                    error: function(data) {
                        console.log(data);
                    },
                    success: function(data) {
                        var response = jQuery.parseJSON(data);

                        if (response.status == 'success')
                        {
                            _modal.modal('hide');
                            _elem.fullCalendar('removeEvents', eventId);
                        }

                        new Messenger().post({
                            message: response.message,
                            hideAfter: 3.5,
                            type: response.status,
                            showCloseButton: true
                        });
                    }
                });
            }
        }).modal('show');
    };

    _this.editEvent = function(eventId, eventStart, eventEnd)
    {
        $.ajax(_currentURL, { data: {ajax: 1, eventResize: 1, eventId: eventId, eventStart: eventStart, eventEnd: eventEnd},
            type: 'POST',
            error: function(data) {
                console.log(data);
            },
            success: function(data) {
                var response = jQuery.parseJSON(data);

                new Messenger().post({
                    message: response.message,
                    hideAfter: 3.5,
                    type: response.status,
                    showCloseButton: true
                });
            }
        });
    };

    _this.EventClick = function(eventId) {
        $.ajax(_currentURL, { data: {ajax: 1, eventClick: 1, eventId: eventId},
            type: 'POST',
            error: function(data) {
                console.log(data);
            },
            success: function(data) {
                var html = jQuery.parseJSON(data);

                _modal.html(html).promise().done(function() {
                    _modal.modal({
                        observeChanges:true,
                        allowMultiple: true,
                        onShow: function() {
                            /*
                                Hack for bad positioning
                             */
                            setTimeout(function () {
                                _modal.modal('refresh');
                            }, 1);
                        }
                    }).modal('show');
                });
            }
        });
    };

    _this.init();
};





